export default "__VITE_ASSET__BomN28_i__"